import axios from "axios";
const baseUrl = "c-road";
export default {
  getProvinces() {
    return axios.get(baseUrl + `/provinces`);
  },
  getListRoad(params){
    return axios.get(baseUrl + `/list`,{
      params: params,
    });
  },
  getListDetail(id){
    return axios.get(baseUrl + `/details?id=${id}`);
  },
  booking(params){
    return axios.post(`c-order-customer/register`,params);
  }
};